import { Autocomplete, DatePicker, Input } from '@fullscreendigital/carrefour-dex-fe'
import { Box } from '@mui/material'
import { IconCell } from 'components/core-ui/IconCell'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import { formatUIDateTime } from "../../../../../utils/helpers"

export const getColumns = (
  navigate,
  isHistorical
) => [
  {
    title: 'Numar comanda',
    field: 'orderNumber',
    align: 'left',
    type: 'string',
    width: '70px'
  },
  {
    title: 'Magazin',
    field: 'shopCode',
    align: 'left',
    type: 'string',
    width: '100px'
  },
  {
    title: 'Nume furnizor',
    field: 'supplierName',
    align: 'left',
    type: 'string',
    width: '100px',
    render: row => `${row.supplierName} (${row?.supplierCode})`,
    disableSorting: true
  },
  {
    title: 'Status',
    field: 'integrationStatus',
    align: 'left',
    type: 'string',
    width: '70px',
    render: row => row.integrationStatusValue
  },
  {
    title: 'Datǎ trimitere către Meti',
    field: 'created',
    align: 'left',
    type: 'string',
    width: '100px',
    disableSorting: true,
    render: row => formatUIDateTime(row.created)
  },
  {
    title: 'Datǎ primire de la Meti',
    field: 'sentTime',
    align: 'left',
    type: 'string',
    width: '100px'
  },
  {
    title: 'Produse cu diferențe',
    field: 'hasDifference',
    align: 'left',
    type: 'string',
    width: '100px',
    render: row => (
      <Box>
        {row.hasDifference ? (
          <div
            onClick={() =>
              navigate(
                isHistorical
                  ? `/shop-reception/suppliers/reception/history/productsDifferences?filters=${encodeURIComponent(JSON.stringify(row))}`
                  : `/shop-reception/suppliers/reception/productsDifferences?filters=${encodeURIComponent(JSON.stringify(row))}`
              )
            }
            style={{ cursor: 'pointer' }}
          >
            <OpenInNewIcon />
          </div>
        ) : (
          ''
        )}
      </Box>
    ),
    disableSorting: true
  },
  {
    title: 'Produse cu diferente Meti',
    field: 'hasMetiDifference',
    align: 'left',
    type: 'string',
    width: '100px',
    render: row => (
      <Box>
        <IconCell value={row.hasMetiDifference ? 'active' : 'inactive'} />
      </Box>
    ),
    disableSorting: true
  },
  {
    title: 'Export produse integrate',
    field: 'integrated',
    align: 'left',
    type: 'string',
    width: '70px',
    render: row => (
      <Box>
        <IconCell value={row.integrated ? 'active' : 'inactive'} />
      </Box>
    ),
    disableSorting: true
  },
  {
    title: 'Erori',
    field: 'hasError',
    align: 'left',
    type: 'string',
    width: '70px',
    render: row => (
      <Box>
        <IconCell value={row.hasError ? 'active' : 'inactive'} />
      </Box>
    ),
    disableSorting: true
  },
  {
    title: 'Detalii',
    field: '',
    align: 'left',
    type: 'string',
    width: '70px',
    disableSorting: true,
    render: row => (
      <Box>
        <div
          onClick={() => {
            const target = isHistorical
              ? `/shop-reception/suppliers/reception/history/orders/${row.orderId}`
              : `/shop-reception/suppliers/admin/orders/${row.orderId}`

            navigate(target, { state: { fromOrdersRow: row } })
          }}
          style={{ cursor: 'pointer' }}
        >
          <OpenInNewIcon />
        </div>
      </Box>
    )
  }
]

export const getDrawerFilters = (shopCodes, statusList) => [
  {
    name: 'orderNumber',
    filter: <Input variant="outlined" label="Numar comanda" type="text" />,
    type: 'text',
    label: 'Numar comanda',
    value: ''
  },
  {
    name: 'shopCode',
    value: '',
    filter: (
      <Autocomplete
        variant="outlined"
        label="Selectează magazin"
        disableClearable
        options={shopCodes || []}
      />
    ),
    type: 'autocomplete',
    label: 'Magazin'
  },
  {
    name: 'supplierCode',
    filter: <Input variant="outlined" label="Cod furnizor" type="number" />,
    type: 'number',
    label: 'Cod furnizor',
    value: ''
  },
  {
    name: 'integrationStatus',
    value: '',
    filter: (
      <Autocomplete
        variant="outlined"
        label="Selectează status"
        disableClearable
        options={statusList || []}
      />
    ),
    type: 'autocomplete',
    label: 'Status'
  },
  {
    name: 'hasDifference',
    value: '',
    filter: (
      <Autocomplete
        variant="outlined"
        label="Selectează cu diferente"
        disableClearable
        options={[
          { label: 'Da', value: 'true' },
          { label: 'Nu', value: 'false' }
        ]}
      />
    ),
    type: 'autocomplete',
    label: 'Cu diferente'
  },
  {
    name: 'integrated',
    value: '',
    filter: (
      <Autocomplete
        variant="outlined"
        label="Selectează produse integrate"
        disableClearable
        options={[
          { label: 'Da', value: 'true' },
          { label: 'Nu', value: 'false' }
        ]}
      />
    ),
    type: 'autocomplete',
    label: 'Produse integrate'
  },
  {
    name: 'sentTime',
    value: '',
    filter: (
      <DatePicker
        label="Selecteaza datǎ primire de la Meti"
        variant="outlined"
        value={null}
        onChange={() => {}}
        adapterLocale="ro"
        modalLabel="Selecteaza data"
        closeButtonLabel="Anuleaza"
        confirmButtonLabel="Confirma"
      />
    ),
    type: 'date',
    label: 'Datǎ primire de la Meti'
  }
]
